import Hangman from "./Hangman";
export default Hangman;